import * as s from "styles/ModalCommonStyled";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";
import BigButton from "components/atoms/buttons/BigButton";
import { videoGuideOptions, type Option } from "utils/options";
import { ValidateWord } from "components/atoms/text/Text";
import SelectComponent from "components/atoms/select/SelectComponent";
import { MdBrokenImage } from "react-icons/md";
import styled from "styled-components";
import { FLEX } from "styles/flex";
import { COLORS } from "styles/colors";
import Spinner from "components/atoms/loader/Spinner";
import { UPDATE_TYPE } from "./AddVideoContainer";
import { VideoGuideVideoDto } from "api/interfaces/managerInterface.interface";
import {
  Validate,
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";

interface Props {
  isEdit: boolean;
  onModal: () => void;
  groupOptions: Option[];
  groupOptionsIsFetching: boolean;
  videoInfo: VideoGuideVideoDto;
  validate: Validate;
  validateMsg: ValidateMsg;
  isInProcess: boolean;
  onChangeUserInfo: (type: UPDATE_TYPE, value: string) => void;
  onDropUrl: (e: React.DragEvent<HTMLInputElement>) => void;
  convertThumbnailUrl: () => void;
  onSaveBefore: () => void;
  maxPosition: number;
}

export default function AddVideoPresenter(props: Props) {
  return (
    <BigPopupTemplate
      title={props.isEdit ? "Edit Video" : "Add Video"}
      onModal={props.onModal}
    >
      <s.Row>
        <ModalInput label="Category" essential half>
          <SelectComponent
            options={videoGuideOptions}
            value={videoGuideOptions[0]?.value}
            disabled={true}
          />
        </ModalInput>
        <ModalInput label="Group" essential half>
          <SelectComponent
            options={props.groupOptions}
            loading={props.groupOptionsIsFetching}
            value={
              props.videoInfo.groupId === ""
                ? props.groupOptions[0]?.value
                : props.videoInfo.groupId
            }
            disabled={props.isInProcess}
            onChange={(value) => {
              props.onChangeUserInfo(UPDATE_TYPE.GROUP, value);
            }}
            data-testid="manager-video-manager-video-select-change-user-info"
          />
        </ModalInput>
      </s.Row>
      <s.Row>
        <ModalInput label="Title" essential>
          <Input
            value={props.videoInfo.title}
            placeholder="Please enter a name."
            onChange={(e) => {
              props.onChangeUserInfo(UPDATE_TYPE.TITLE, e.target.value);
            }}
            isValidated={props.validate.title}
            disabled={props.isInProcess}
            data-testid="manager-video-manager-video-input-change-user-info"
          />

          <ValidateWord data-testid="manager-video-manager-video-validate-title">
            {props.validateMsg.title}
          </ValidateWord>
        </ModalInput>
      </s.Row>
      <s.Row>
        <ModalInput label="Video URL" essential>
          <RowInput>
            <Input
              type="url"
              value={props.videoInfo.videoUrl}
              placeholder="Enter a video URL."
              onChange={(e) => {
                props.onChangeUserInfo(UPDATE_TYPE.VIDEO_URL, e.target.value);
              }}
              isValidated={props.validate.videoUrl}
              onDrop={props.onDropUrl}
              disabled={props.isInProcess}
              data-testid="manager-video-manager-video-input-change-user-info-2"
            />

            <BigButton
              label={"Thumbnail"}
              onClickBtn={props.convertThumbnailUrl}
              data-testid="manager-video-manager-video-button-convert-thumbnail-url"
            />
          </RowInput>
          <ValidateWord data-testid="manager-video-manager-video-validate-video-url">
            {props.validateMsg.videoUrl}
          </ValidateWord>
        </ModalInput>
      </s.Row>
      <s.Row>
        <ModalInput label="Thumbnail" half>
          <PreThumb>
            {
              props.videoInfo.thumbnailUrl !== "" ? (
                <img src={props.videoInfo.thumbnailUrl} alt="video_Thumbnail" />
              ) : (
                <>
                  <MdBrokenImage size={100} color="red" />
                  <p>Thumbnail not Available</p>
                </>
              )

              // : <img src={VideoShareBroken} alt="video-share-broken" />
            }
          </PreThumb>
        </ModalInput>
        <ModalInput label="Order" half>
          <Input
            type="number"
            min={1}
            value={props.videoInfo.position}
            placeholder="Enter a order for this guide."
            onChange={(e) => {
              props.onChangeUserInfo(UPDATE_TYPE.ORDER, e.target.value);
            }}
            disabled={props.isInProcess}
            max={props.maxPosition}
            data-testid="manager-video-manager-video-input-change-user-info-3"
          />
        </ModalInput>
      </s.Row>
      <ModalInput label="Description">
        <Input
          value={props.videoInfo.description}
          placeholder="Please enter a description"
          onChange={(e) => {
            props.onChangeUserInfo(UPDATE_TYPE.DESC, e.target.value);
          }}
          disabled={props.isInProcess}
          data-testid="manager-video-manager-video-input-change-user-info-4"
        />
      </ModalInput>
      <ActionBtns
        isInProcess={props.isInProcess}
        onSaveBefore={props.onSaveBefore}
      />
    </BigPopupTemplate>
  );
}

type ActionBtnstype = {
  isInProcess: boolean;
  onSaveBefore: () => void;
};

const ActionBtns = ({ isInProcess, onSaveBefore }: ActionBtnstype) => {
  if (isInProcess) {
    return (
      <s.ButtonWrapper>
        <Spinner size={8} inline={true} />
      </s.ButtonWrapper>
    );
  }
  return (
    <s.ButtonWrapper>
      <BigButton
        label="Save"
        onClickBtn={onSaveBefore}
        disabled={isInProcess}
        data-testid="manager-video-manager-video-button-save-before"
      />
    </s.ButtonWrapper>
  );
};

const PreThumb = styled.div`
  width: 100%;
  height: 200px;
  border: 1px solid ${COLORS.BORDER};
  text-align: center;

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  > svg {
    margin: 20px;
  }
  > p {
    color: red;
  }
`;

const RowInput = styled.div`
  ${FLEX.FlexBetweenCenter};
  gap: 15px;
  width: 100%;

  .account-block {
    flex: 1;
    width: 100%;
    height: 100%;
  }
  > button {
    padding: 10px;
  }
`;
